import React, { useEffect, useRef, useState } from 'react';

const OPTIONS = [
  { value: 'latest', label: '기본 정렬' },
  { value: 'name', label: '이름순 정렬' },
];

// Figma: 124x43px, border 1px solid #E5E5E5, border-radius 5px, NotoSansCJKkr 400 14px, letter-spacing -0.5px
const SortButton = ({ value = 'latest', onChange }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const current = OPTIONS.find((o) => o.value === value) || OPTIONS[0];

  return (
    <div className="relative" ref={ref} style={{ fontFamily: "'Noto Sans CJK KR', NotoSansCJKkr, sans-serif" }}>
      <button
        type="button"
        onClick={() => setOpen((p) => !p)}
        className="w-[124px] h-[43px] border border-[#E5E5E5] rounded-[5px] flex items-center justify-between px-[22px] bg-white cursor-pointer"
        style={{ letterSpacing: '-0.5px', fontSize: 14, color: '#000000' }}
      >
        <span>{current.label}</span>
        <span className={`transition-transform ${open ? 'rotate-180' : ''}`} style={{ fontSize: 10 }}>
          ▾
        </span>
      </button>
      {open && (
        <ul className="absolute right-0 top-[44px] w-[124px] border border-[#E5E5E5] rounded-[5px] bg-white z-20 m-0 p-0 list-none">
          {OPTIONS.map((o) => (
            <li
              key={o.value}
              onClick={() => {
                onChange && onChange(o.value);
                setOpen(false);
              }}
              className="h-[43px] flex items-center px-[22px] cursor-pointer hover:bg-[#F5F5F5]"
              style={{
                letterSpacing: '-0.5px',
                fontSize: 14,
                color: '#000000',
                fontWeight: o.value === value ? 700 : 400,
              }}
            >
              {o.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SortButton;
